import React from "react";
import CardFacility from "./Cards/CardFacility";

export default function Facilities() {
  return (
    <section className=" lg:py-5 lg:w-5/6 lg:mx-auto lg:mb-24">
      <div className="my-16 space-y-10 2xl:space-y-0 flex flex-col lg:flex-row lg:mt-16 lg:mb-24 2xl:my-24 items-center justify-center lg:space-x-20">
        <div className="w-5/6 lg:w-0 flex items-center justify-start">
          <p className="lg:hidden text-sm text-gray-500">
            Fasilitas Pendukung{" "}
          </p>
          <p className="lg:hidden text-blue-400 mb-3 ml-3">
            {" "}
            __________________________
          </p>
        </div>

        <img className="lg:w-32" src="assets/logo-bpjs.png" alt="" />
        <img className="lg:w-32" src="assets/logo-pedulilindungi.png" alt="" />
        <img className="lg:w-32" src="assets/logo-halodoc.png" alt="" />
      </div>
      <div className=" w-5/6 mx-auto space-y-6 lg:flex-col lg:items-center lg:justify-center 2xl:mt-24 2xl:space-y-8">
        <h1
          className="font-bold text-2xl sm:text-4xl 2xl:text-5xl text-center"
          id="facilities"
        >
          Fasilitas-Fasilitas
        </h1>
        <p className="p-3 text-center text-gray-500">
          Kami menyediakan beragam fasilitas untuk membantu melayani masyarakat
        </p>
      </div>

      <div className=" z-[200] space-y-14 lg:space-y-0 mt-12 2xl:mt-16 lg:grid lg:grid-cols-3  lg:gap-24  2xl:gap-32">
        {/* <div className="sm:hidden bg-blue-300 absolute w-screen h-screen  -top-32  -z-10 rotate-[-45deg]  rounded-full opacity-10  "></div>
        <div className="sm:hidden bg-blue-300 absolute w-screen h-96  top-64 z-10   opacity-10  "></div> */}

        <CardFacility
          source={"assets/poligigi.png"}
          title={"Poli Gigi"}
          text={
            "Kami menyediakan pelayanan Poli Gigi oleh tim dokter yang kompeten. Poli Gigi memberikan pelayanan kesehatan gigi dan mulut, pengobatan dan pemberian tindakan medis dasar kesehatan gigi dan mulut seperti penambalan gigi, pencabutan gigi dan pembersihan karang gigi."
          }
        />


        <CardFacility
          source={"assets/poliumum1.png"}
          title={"Poli Umum"}
          text={`Klinik Mora Medika memberikan pelayanan yang berfokus pada kegiatan promotif, preventif, kuratif dan rehabilitatif.`}
        />
        <CardFacility
          source={"assets/poliumum2.png"}
          title={"Rawat Jalan"}
          text={
            "Klinik kami sebagai layanan tingkat pertama yang berperan dalam memberikan pecegahan, diagnosis, penanganan awal, dan rujukan ke dokter spesialis jika diperlukan."
          }
        />
        <CardFacility
          source={"assets/labor2.png"}
          title={"Laboratorium"}
          text={
            "Kami memiliki laboratorium untuk pengujian berbagai sampel untuk mendapatkan informasi tentang kesehatan perorangan."
          }
        />
        <CardFacility
          source={"assets/persalinan.png"}
          title={"Kebidanan"}
          text={
            "Kami memberikan pelayanan kebidanan kepada perempuan selama masa sebelum hamil, masa kehamilan dan persalinan."
          }
        />
        <CardFacility
          source={"assets/ugd.png"}
          title={"Pelayanan UGD"}
          text={
            "Kami menyediakan penanganan awal bagi pasien dengan kondisi medis darurat"
          }
        />
      </div>
    </section>
  );
}
